import { CheveronRightIcon } from '@wkda/icons';
import { AlertBox, Button } from '@wkda/styleguide';
import { Field, Form } from 'react-final-form';
import FieldError from '../FieldError';
import carImage from './images/car.png';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const emailRegex =
// eslint-disable-next-line no-useless-escape
/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9])+$/;
export default function EmailSubscription(_ref) {
  let {
    mainTitle,
    mainSubtitle,
    successMessageDesktop,
    successMessageMobile,
    invalidEmailErrorMessage,
    emailFieldPlaceholder,
    emailFieldLabel,
    submitButtonText,
    contentDescription,
    onSubmitHandler,
    status
  } = _ref;
  return /*#__PURE__*/_jsx("article", {
    className: "email-subscription text-white bg-primary px-4 py-4",
    children: /*#__PURE__*/_jsxs("div", {
      className: "d-flex justify-content-center align-items-center mx-auto email-subscription__content",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "mr-4",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "h4 font-weight-semibold",
          children: mainTitle
        }), /*#__PURE__*/_jsx("p", {
          className: "mb-2",
          children: mainSubtitle
        }), /*#__PURE__*/_jsx(Form, {
          onSubmit: _ref2 => {
            let {
              subscriptionEmail
            } = _ref2;
            return onSubmitHandler(subscriptionEmail);
          },
          validate: values => {
            if (!emailRegex.test(values.subscriptionEmail)) {
              return {
                subscriptionEmail: invalidEmailErrorMessage
              };
            }
          },
          render: function formRender(_ref3) {
            let {
              handleSubmit
            } = _ref3;
            return status === 'success' ? /*#__PURE__*/_jsxs(AlertBox, {
              variant: "success",
              className: "email-subscription__alert",
              children: [/*#__PURE__*/_jsx("div", {
                className: "d-none d-sm-block",
                children: successMessageDesktop
              }), /*#__PURE__*/_jsx("div", {
                className: "d-block d-sm-none",
                children: successMessageMobile
              })]
            }) : /*#__PURE__*/_jsxs("form", {
              noValidate: true,
              method: "post",
              onSubmit: handleSubmit,
              children: [/*#__PURE__*/_jsx("label", {
                className: "visually-hidden",
                htmlFor: "subscription-email",
                children: emailFieldLabel
              }), /*#__PURE__*/_jsxs("div", {
                className: "input-group input-group-lg",
                children: [/*#__PURE__*/_jsx(Field, {
                  name: "subscriptionEmail",
                  type: "email",
                  component: "input",
                  id: "subscription-email",
                  placeholder: emailFieldPlaceholder,
                  className: "form-control"
                }), /*#__PURE__*/_jsx("div", {
                  className: "input-group-append",
                  children: /*#__PURE__*/_jsxs(Button, {
                    className: "px-sm-4",
                    type: "submit",
                    variant: "secondary",
                    disabled: status === 'loading',
                    children: [submitButtonText, /*#__PURE__*/_jsx(CheveronRightIcon, {
                      className: "ml-2"
                    })]
                  })
                })]
              }), /*#__PURE__*/_jsx(FieldError, {
                name: "subscriptionEmail"
              })]
            });
          }
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "d-none d-md-block",
        children: /*#__PURE__*/_jsx("img", {
          className: "img-fluid",
          src: carImage,
          alt: "white suburban vehicle"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "email-subscription__description",
        children: /*#__PURE__*/_jsx("p", {
          className: "font-size-sm mb-0",
          children: contentDescription
        })
      })]
    })
  });
}